import PursuitStars from 'assets/pursuit-stars.png';
import PursuitScribble from 'assets/pursuit-scribble.png';
import PursuitSpin from 'assets/pursuit-spin.png';
import PursuitArrow from 'assets/pursuit-arrow.png';
import PursuitPlus from 'assets/pursuit-plus.png';

import { colors } from 'styles/theme';

export const getBackgroundColor = (index: number) => {
    const colorOptions = [
        colors.pursuitGreen,
        colors.pursuitBlue,
        colors.pursuitGold,
        colors.pursuitOrange,
    ];

    return colorOptions[index % colorOptions.length];
};

export const getPursuitImageUrl = (index: number) => {
    const imageOptions = [
        PursuitStars,
        PursuitScribble,
        PursuitSpin,
        PursuitArrow,
        PursuitPlus,
    ];

    return imageOptions[index % imageOptions.length];
};
